import React from "react";
import { Navigate } from "react-router-dom";
import PathConstants from "./path-constants";
import ClaimableAuthenticatorV2 from "../components/shared/claimable-authenticator-v2";
import { FormDirtyLayout } from "../components/navigation-blocker";

const CoverageFundEligibilityPage = React.lazy(
  () =>
    import("../pages/product/eligibility/coverage-fund/coverage-fund-eligibility"),
);
const MedicationConditionEligibilityPage = React.lazy(
  () => import("../pages/product/eligibility/medication-condition-eligibility"),
);
const DenialReasonEligibilityPage = React.lazy(
  () => import("../pages/product/eligibility/denial-reason-eligibility"),
);
const SubDenialReasonEligibilityPage = React.lazy(
  () =>
    import("../pages/product/eligibility/sub-denial-reason-eligibility/sub-denial-reason-eligibility"),
);
const BMICriteriaFollowUpPage = React.lazy(
  () =>
    import("../pages/product/eligibility/sub-denial-reason-eligibility/bmi-criteria-follow-up"),
);
const AlternativeConditionEligibilityPage = React.lazy(
  () =>
    import("../pages/product/eligibility/alternative-condition-eligibility"),
);
const PatientInfo = React.lazy(
  () => import("../pages/product/eligibility/patient-info"),
);
const WhoIsAppealFor = React.lazy(
  () => import("../pages/product/eligibility/who-is-appeal-for"),
);
const CoverageFundQualifyPage = React.lazy(
  () =>
    import("../pages/product/eligibility/coverage-fund/coverage-fund-qualify"),
);
const LetsGetStarted = React.lazy(
  () => import("../pages/product/setup-flow/lets-get-started"),
);
const CoverageFundNotQualifyPage = React.lazy(
  () =>
    import("../pages/product/eligibility/coverage-fund/coverage-fund-not-qualify"),
);

const routes = [
  {
    path: PathConstants.Root,
    element: <Navigate to={PathConstants.MedicationConditionEligibility} />,
  },
  {
    path: PathConstants.CoverageFundEligibility,
    element: <CoverageFundEligibilityPage />,
  },
  {
    path: PathConstants.MedicationConditionEligibility,
    element: <MedicationConditionEligibilityPage />,
  },
  {
    path: PathConstants.DenialReasonEligibility,
    element: <DenialReasonEligibilityPage />,
  },
  {
    path: PathConstants.SubDenialReasonEligibility,
    element: <SubDenialReasonEligibilityPage />,
  },
  {
    path: PathConstants.BMICriteriaFollowUp,
    element: <BMICriteriaFollowUpPage />,
  },
  {
    path: PathConstants.AlternativeConditionEligibility,
    element: <AlternativeConditionEligibilityPage />,
  },
  {
    element: <FormDirtyLayout />,
    children: [
      {
        path: PathConstants.PatientInfo,
        element: (
          <ClaimableAuthenticatorV2>
            <PatientInfo />
          </ClaimableAuthenticatorV2>
        ),
      },
      {
        path: PathConstants.WhoIsAppealFor,
        element: (
          <ClaimableAuthenticatorV2>
            <WhoIsAppealFor />
          </ClaimableAuthenticatorV2>
        ),
      },
    ],
  },
  {
    path: PathConstants.CoverageFundQualify,
    element: <CoverageFundQualifyPage />,
  },
  {
    path: PathConstants.CoverageFundNotQualify,
    element: <CoverageFundNotQualifyPage />,
  },
  {
    path: PathConstants.LetsGetStarted,
    element: (
      <ClaimableAuthenticatorV2>
        <LetsGetStarted />
      </ClaimableAuthenticatorV2>
    ),
    className: "body_background_light-volt-fade-down",
  },
];

export default routes;
